// In every file you need this!

// import $ from 'jquery';
// //attach jquery to dom
// window.jQuery = $;
// window.$ = $;

(function($) { 
  $(document).ready(function() {
    $( ".post_image" ).hover(
      function() {
        $(".white_cover", this).addClass( "hover" );
      }, function() {
        $(".white_cover", this).removeClass( "hover" );
      }
    );

    $( ".new_box" ).hover(
      function() {
        $(".new_box_title", this).addClass( "active" );
      }, function() {
        $(".new_box_title", this).removeClass( "active" );
      }
    );
  });
})(jQuery);